<div fxLayout="row wrap" fxLayoutCap="5px">
  <mat-chip-list>
    <mat-chip color="danger" *ngFor="let group of sortServiceGroupList" (removed)="agent_remove_group(group)"
      [matTooltip]="group.name">
      {{group.name | truncate:20}}
      <mat-icon *ngIf="is_admin_or_supervisor()" matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
</div>
